import LoyaltyList from '@app/Loyalty/List'
import LoyaltyListUkraine from '@app/Loyalty/ListUkraine'
import LoyaltySpecialPrices from '@app/Loyalty/SpecialPrices'

export default function install(Vue) {
  Vue.component('LoyaltyList', LoyaltyList)
  Vue.component('LoyaltyListUkraine', LoyaltyListUkraine)
  Vue.component('LoyaltySpecialPrices', LoyaltySpecialPrices)
}
